<div class="view-container">
<mat-card class="company-create-card">
  <div class="company-create-card__header">
    <div class="company-create-card__title-row">
      <div class="company-create-card__icon">
        <mat-icon>business</mat-icon>
      </div>
      <div>
        <h1 class="company-create-card__title">New {{ selectedCompanyType ? selectedCompanyType.type : 'Company' }}</h1>
        <p class="company-create-card__subtitle">Capture company and address details</p>
      </div>
    </div>
  </div>

  <mat-stepper linear #stepper class="company-create-card__stepper">
    <mat-step [stepControl]="companyDetailsForm">
      <ng-template matStepLabel>Company details</ng-template>
      <form class="mt-4" [formGroup]="companyDetailsForm">
        <h3 class="company-create-card__section-title">Company details</h3>
        <div class="row">
          <div class="col-md-6">

            <p>
              <mat-form-field appearance="outline">
                <mat-label>Company name</mat-label>
                <input required data-testid="company-name" type="text" aria-label="Company name" matInput formControlName="companyName">
              </mat-form-field>
            </p>

            <p>
              <mat-form-field appearance="outline">
                <mat-label>Phone number</mat-label>
                <input required data-testid="company-phone-number" formControlName="phoneNumber" matInput>
                @if (companyDetailsForm.get('phoneNumber')?.invalid) {
                  <mat-error>
                    Phone number is invalid
                  </mat-error>
                }
              </mat-form-field>
            </p>

            <p>
              <mat-form-field appearance="outline">
                <mat-label>Alternative phone number</mat-label>
                <input data-testid="company-phone-number-alt" formControlName="phoneNumberAlt" matInput>
                @if (companyDetailsForm.get('phoneNumberAlt')?.invalid) {
                  <mat-error>
                    Alternative phone number is invalid
                  </mat-error>
                }
              </mat-form-field>
            </p>

            <p>
              <mat-form-field appearance="outline">
                <mat-label>Email address</mat-label>
                <input required data-testid="company-email" formControlName="email" matInput>
                @if (companyDetailsForm.get('email')?.invalid) {
                  <mat-error>
                    Email address is invalid
                  </mat-error>
                }
              </mat-form-field>
            </p>

          </div>
          <div class="col-md-6">

            <p>
              <mat-form-field appearance="outline">
                <mat-label>Alternative email address</mat-label>
                <input data-testid="company-email-alt" formControlName="emailAlt" matInput>
                @if (companyDetailsForm.get('emailAlt')?.invalid) {
                  <mat-error>
                    Alternative email address is invalid
                  </mat-error>
                }
              </mat-form-field>
            </p>

            <p>
              <mat-form-field appearance="outline">
                <mat-label>Practice number</mat-label>
                <input data-testid="company-practice-number" formControlName="practiceNumber" matInput>
                @if (companyDetailsForm.get('practiceNumber')?.invalid) {
                  <mat-error>
                    Practice number is invalid
                  </mat-error>
                }
              </mat-form-field>
            </p>

            <p>
              <mat-form-field appearance="outline">
                <mat-label>VAT registration number</mat-label>
                <input data-testid="company-vat-reg-number" formControlName="vatRegistrationNumber" matInput>
                @if (companyDetailsForm.get('vatRegistrationNumber')?.invalid) {
                  <mat-error>
                    VAT registration number is invalid
                  </mat-error>
                }
              </mat-form-field>
            </p>

            <p>
              <mat-form-field appearance="outline">
                <mat-label>Type</mat-label>
                <mat-select required data-testid="company-type" formControlName="companyType">
                  @for (type of companyTypes; track type) {
                    <mat-option [value]="type">
                      {{type.type}}
                    </mat-option>
                  }
                </mat-select>
                @if (companyDetailsForm.get('companyType')?.invalid) {
                  <mat-error>
                    Select type
                  </mat-error>
                }
              </mat-form-field>
            </p>

            @if (isDistributorType()) {
              <p>
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Invoice mode</mat-label>
                  <mat-select required data-testid="distributor-invoice-mode" formControlName="invoiceMode">
                    @for (opt of invoiceModeOptions; track opt) {
                      <mat-option [value]="opt.value">
                        {{ opt.label }}
                      </mat-option>
                    }
                  </mat-select>
                  @if (companyDetailsForm.get('invoiceMode')?.invalid) {
                    <mat-error>
                      Invoice mode is required
                    </mat-error>
                  }
                </mat-form-field>
              </p>
              @if (companyDetailsForm.get('invoiceMode')?.value === 'GROUP_WEEKLY') {
                <p>
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Weekly invoice day</mat-label>
                    <mat-select required data-testid="distributor-weekly-day" formControlName="weeklyInvoiceDay">
                      @for (d of weeklyInvoiceDayOptions; track d) {
                        <mat-option [value]="d.value">
                          {{ d.label }}
                        </mat-option>
                      }
                    </mat-select>
                    @if (companyDetailsForm.get('weeklyInvoiceDay')?.invalid) {
                      <mat-error>
                        Weekly invoice day is required
                      </mat-error>
                    }
                  </mat-form-field>
                </p>
              }
              <p class="d-flex align-items-center">
                <mat-slide-toggle formControlName="isActive" data-testid="distributor-active">
                  Active
                </mat-slide-toggle>
              </p>
            }

          </div>
        </div>

        @if (showDistributor) {
          <div class="my-2">
            <div class="py-2 mt-4">
              <mat-divider></mat-divider>
            </div>
            <h3 class="company-create-card__section-title">Distributor</h3>
            <p>
              @if (!selectedDistributor) {
                <button type="button" mat-stroked-button (click)="openSearchDistributorDialog()">
                  Select distributor
                </button>
              }
            </p>
            @if (selectedDistributor) {
              <div class="details mt-2">
                <button type="button" mat-stroked-button (click)="deselectDistributor()" class="me-2 my-2">
                  <mat-icon>cancel</mat-icon> Remove
                </button>
                <table class="mt-4">
                  <tr>
                    <th>Name</th>
                    <td>{{ selectedDistributor.name ? selectedDistributor.name : '-' }}</td>
                  </tr>
                  <tr>
                    <th>Alternative email address</th>
                    <td>{{ selectedDistributor.email_alt ? selectedDistributor.email_alt : '-' }}</td>
                  </tr>
                  <tr>
                    <th>Phone number</th>
                    <td>{{ selectedDistributor.phone_number ? selectedDistributor.phone_number : '-' }}</td>
                  </tr>
                  <tr>
                    <th>Email</th>
                    <td>{{ selectedDistributor.email ? selectedDistributor.email : '-' }}</td>
                  </tr>
                  <tr>
                    <th>Alternative phone number</th>
                    <td>{{ selectedDistributor.phone_number_alt ? selectedDistributor.phone_number_alt : '-' }}</td>
                  </tr>
                  <tr>
                    <th>Practice number</th>
                    <td>{{ selectedDistributor.practice_number ? selectedDistributor.practice_number : '-' }}</td>
                  </tr>
                  <tr>
                    <th>VAT registration number</th>
                    <td>{{ selectedDistributor.vat_registration_number ? selectedDistributor.vat_registration_number : '-' }}</td>
                  </tr>
                </table>
              </div>
            }
          </div>
        }
      </form>

      <div class="company-create-card__footer">
        <button
          type="button"
          data-testid="next-step"
          [disabled]="!companyDetailsForm.valid || (showDistributor && !selectedDistributor)"
          color="primary"
          mat-flat-button
          class="company-create-card__btn--primary"
          matStepperNext
        >
          <mat-icon>chevron_right</mat-icon> Next
        </button>
      </div>
    </mat-step>
    <mat-step [stepControl]="addressDetailsForm">
      <ng-template matStepLabel>Address details</ng-template>
      <form [formGroup]="addressDetailsForm">

        <div class="row">
          <div class="col-md-6">

            <p>
              <mat-form-field appearance="outline">
                <mat-label>Search for a country</mat-label>
                <input required [disabled]="isLoading" type="text"
                  aria-label="Search for a country" matInput formControlName="country"
                  [matAutocomplete]="auto">
                <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                  @for (country of filteredCountriesForIndividual | async; track country) {
                    <mat-option [value]="country.name">
                      {{country.name}}
                    </mat-option>
                  }
                </mat-autocomplete>
                <mat-icon matPrefix>search</mat-icon>
                @if (addressDetailsForm.get('country')?.invalid) {
                  <mat-error>
                    Country is invalid
                  </mat-error>
                }
              </mat-form-field>
            </p>

            <p>
              <mat-form-field appearance="outline">
                <mat-label>Province</mat-label>
                <mat-select required data-testid="individual-province" formControlName="province">
                  @for (province of provinces; track province) {
                    <mat-option value="{{province.name}}">
                      {{province.name}}
                    </mat-option>
                  }
                </mat-select>
                @if (addressDetailsForm.get('province')?.invalid) {
                  <mat-error>
                    Province is invalid
                  </mat-error>
                }
              </mat-form-field>
            </p>

            <p>
              <mat-form-field appearance="outline">
                <mat-label>City</mat-label>
                <input type="text" formControlName="city" matInput />
                @if (addressDetailsForm.get('city')?.invalid) {
                  <mat-error>
                    City is invalid
                  </mat-error>
                }
              </mat-form-field>
            </p>

            <p>
              <mat-form-field appearance="outline">
                <mat-label>Address line 1</mat-label>
                <input required data-testid="individual-address-line-1" formControlName="addressLine1" matInput>
                @if (addressDetailsForm.get('addressLine1')?.invalid) {
                  <mat-error>
                    Address Line 1 is invalid
                  </mat-error>
                }
              </mat-form-field>
            </p>

          </div>

          <div class="col-md-6">

            <p>
              <mat-form-field appearance="outline">
                <mat-label>Suburb</mat-label>
                <input data-testid="individual-address-line-2" formControlName="addressLine2" matInput>
                @if (addressDetailsForm.get('addressLine2')?.invalid) {
                  <mat-error>
                    Suburb is invalid
                  </mat-error>
                }
              </mat-form-field>
            </p>

            <p>
              <mat-form-field appearance="outline">
                <mat-label>Building number</mat-label>
                <input data-testid="individual-building-apt-number" formControlName="buildingAptNumber"
                  type="number" min="1" matInput>
                @if (addressDetailsForm.get('buildingAptNumber')?.invalid) {
                  <mat-error>
                    Building number is required
                  </mat-error>
                }
              </mat-form-field>
            </p>

            <p>
              <mat-form-field appearance="outline">
                <mat-label>Postcode</mat-label>
                <input required data-testid="individual-postcode" formControlName="postcode" matInput>
                @if (addressDetailsForm.get('postcode')?.invalid) {
                  <mat-error>
                    Postcode is invalid
                  </mat-error>
                }
              </mat-form-field>
            </p>

          </div>
        </div>

      </form>

      <div class="company-create-card__footer">
        <button type="button" class="company-create-card__btn" data-testid="previous-step" mat-stroked-button matStepperPrevious>
          <mat-icon>chevron_left</mat-icon> Back
        </button>

        <button
          type="button"
          data-testid="next-step"
          (click)="save()"
          [disabled]="!companyDetailsForm.valid || !addressDetailsForm.valid || (showDistributor && !selectedDistributor)"
          color="primary"
          mat-flat-button
          class="company-create-card__btn--primary"
        >
          <mat-icon>save</mat-icon> Save
        </button>
      </div>
    </mat-step>
  </mat-stepper>
</mat-card>
</div>
